const messages = {
    buttons: {
        productBrochures: "Opdag",
    },
    index: {
        title: "PRODUKTINFORMATION",
        description: "Download her de seneste brochurer og flyers fra vores Bridgestone- og Firestone-dæk.",
        categories: {
            productBrochures: {
                title: "Produktbrochurer",
                description: "Brochurer fra Bridgestone- og Firestone-dækserier",
            },
            bDrive: {
              title: "Produktbilleder",
              description: "Du kan finde aktuelle billeder til download i vores B-DRIVE-portal.",
            },
        
          kickback: {
            description: "Den teilnehmenden Unternehmen werden Kickback-Gebühren auf Basis der übermittelten Umsatzzahlen gutgeschrieben.",
          },}
    }
};

export default {
    messages,
};

